// extracted by mini-css-extract-plugin
module.exports = {"SourceOfIncome":"index-module_SourceOfIncome_3gY8B"};